// @ts-nocheck

import PropTypes from 'prop-types';
import React from 'react';
import { Layer, Source } from 'react-map-gl/mapbox';
import { useSelector } from 'react-redux';

import { getHeatmapData } from '@/store/selectors/reporting.selectors';

function HeatmapLayer({ intensity, mapId, metric, radius, show }) {
  const data = useSelector(store => getHeatmapData(store, mapId));
  if (!data || !show) {
    return null;
  }
  return (
    <Source data={data} id="heatmap_source" type="geojson">
      <Layer
        id="heatmap_layer"
        paint={{
          'heatmap-intensity': intensity,
          'heatmap-opacity': 0.8,
          'heatmap-radius': radius * 100,
          'heatmap-weight': {
            property: metric,
            type: 'identity'
          }
        }}
        type="heatmap"
      />
    </Source>
  );
}

HeatmapLayer.propTypes = {
  intensity: PropTypes.number.isRequired,
  metric: PropTypes.string.isRequired,
  radius: PropTypes.number.isRequired,
  show: PropTypes.bool
};
HeatmapLayer.defaultProps = {
  show: true
};

export default React.memo(HeatmapLayer);
